module.exports = __webpack_public_path__ + "img/border.93e29c5f.svg";